import { colors } from '../../colors';
var button = {
  //Hero button
  isHeroGradient: true,
  linkColorHero: colors.white,
  linkColorHeroHover: colors.white,
  backgroundColorHero: colors.pumpkinOrange,
  backgroundColorHoverHero: colors.deepOrange,
  borderRadiusHero: '0',
  linkLineHeightHero: '30px',
  heroButtonPadding: '20px 35px',
  //primary button
  isPrimaryGradient: true,
  linkColorPrimary: colors.white,
  linkColorPrimaryHover: colors.white,
  backgroundColorPrimary: colors.pumpkinOrange,
  backgroundColorHoverPrimary: colors.deepOrange,
  borderRadiusPrimary: '0',
  //secondary button
  isSecondaryGradient: false,
  linkColorSecondary: colors.white,
  linkColorSecondaryHover: colors.white,
  backgroundColorSecondary: colors.deepOrange,
  backgroundColorHoverSecondary: colors.scarlet,
  borderRadiusSecondary: '0',
  borderColorSecondary: 'transparent',
  borderColorSecondaryHover: 'transparent'
};
export default button;